import React from 'react'
import {useHomepageContent} from '../hooks/useHomepageContent'
import {useAnalytics} from '../hooks/useAnalytics'
import SEOHead from '../components/SEOHead'
import HeroSection from '../components/homepage/HeroSection'
import HowItWorksSection from '../components/homepage/HowItWorksSection'
import TestimonialsSection from '../components/homepage/TestimonialsSection'
import NewsletterSection from '../components/homepage/NewsletterSection'
import FAQSection from '../components/homepage/FAQSection'
import LoadingSpinner from '../components/ui/LoadingSpinner'

const Home = () => {
  const {content, loading} = useHomepageContent()
  const {trackCTAClick} = useAnalytics()

  // Handle CTA clicks
  const handleCTAClick = (ctaName, destination) => {
    trackCTAClick(ctaName, 'homepage', destination)
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <LoadingSpinner size="xl" />
      </div>
    )
  }

  return (
    <div className="min-h-screen">
      <SEOHead
        title="Sustainable Weight Loss for LIFE | Empower Nutrition"
        description="Learn simple, sustainable nutrition habits that work with your real life. No restrictive diets, just proven methods for lasting weight loss and better health."
        keywords="sustainable weight loss, nutrition coaching, healthy habits, PPC method, real world nutrition, lasting weight loss"
        url="/"
        image="https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1200&h=630&fit=crop"
      />
      
      <HeroSection 
        content={content.hero} 
        onCTAClick={handleCTAClick}
      />
      <HowItWorksSection 
        content={content.howItWorks}
        onCTAClick={handleCTAClick}
      />
      <TestimonialsSection content={content.testimonials} />
      <NewsletterSection 
        content={content.newsletter}
        onCTAClick={handleCTAClick}
      />
      <FAQSection content={content.faq} />
    </div>
  )
}

export default Home